<template>
  <HomeInicio />
  <div
    v-if="paquete === 4"
    class="add-invitados-container"
  >
    <h2>Escanear Código QR</h2>

    <div v-if="!scannedData">
      <button
        class="btn btn-danger"
        @click="toggleCamera"
      >
        {{ videoStream ? "Detener Cámara" : "Activar Cámara" }}
      </button>

      <div
        v-show="videoStream"
        class="video-container"
      >
        <video
          ref="videoElement"
          autoplay
          playsinline
        />
        <canvas
          ref="canvasElement"
          class="d-none"
        />
      </div>
    </div>

    <div
      v-if="scannedData"
      class="scanned-container"
    >
      <p><strong>Datos escaneados:</strong></p>
      <p>{{ scannedData }}</p>
      <iframe
        v-if="isValidUrl(scannedData)"
        :src="scannedData"
      />
      <button
        class="btn btn-primary mt-3"
        @click="resetScanner"
      >
        Regresar
      </button>
    </div>
  </div>
  <!-- Mostrar mensaje si el paquete es igual a 4 -->
   
  <!-- Mostrar mensaje si el paquete no es 4 -->
  <div
    v-else
    class="nodisponible2"
  >
    <div class="contenedornodisp">
      <p>Esta sección no está disponible en el paquete contratado.</p> 
    </div>

  </div>
</template>

<script>
import jsQR from "jsqr";
import HomeInicio from "@/components/HomeInicio.vue";

export default {
  name: "LectorQR",
  components: {
    HomeInicio,

  },
  data() {
    return {
      scannedData: null,
      videoStream: null,
      scanning: false,
      paquete: Number(localStorage.getItem('paquete')), // Recupera el paquete de localStorage

    };
  },
  methods: {
    async toggleCamera() {
      if (this.videoStream) {
        this.stopCamera();
      } else {
        await this.startCamera();
      }
    },
    async startCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: { facingMode: "environment" },
        });

        this.videoStream = stream;
        this.$refs.videoElement.srcObject = stream;
        this.$refs.videoElement.setAttribute("playsinline", true); // Evita que algunos dispositivos entren en pantalla completa

        this.$refs.videoElement.onloadedmetadata = () => {
          console.log("Video listo, iniciando escaneo...");
          this.$refs.videoElement.play();
          this.scanning = true;
          this.scanQRCode();
        };
      } catch (error) {
        console.error("Error al acceder a la cámara:", error);
      }
    },
    stopCamera() {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
        this.videoStream = null;
      }
      this.scanning = false;
    },
    scanQRCode() {
      if (!this.scanning) return;

      const video = this.$refs.videoElement;
      const canvas = this.$refs.canvasElement;
      const ctx = canvas.getContext("2d");

      const scanFrame = () => {
        if (!this.scanning) return;

        // Verificar que el video tiene dimensiones válidas antes de procesarlo
        if (video.videoWidth === 0 || video.videoHeight === 0) {
          console.warn("Esperando a que el video cargue...");
          setTimeout(scanFrame, 500); // Esperar 500ms y volver a intentar
          return;
        }

        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const qrCode = jsQR(imageData.data, canvas.width, canvas.height);

        if (qrCode) {
          this.scannedData = qrCode.data;
          this.stopCamera();
        } else {
          requestAnimationFrame(scanFrame);
        }
      };

      requestAnimationFrame(scanFrame);
    },
    resetScanner() {
      this.scannedData = null;
      this.startCamera();
    },
    isValidUrl(string) {
      try {
        new URL(string);
        return true;
      } catch (_) {
        return false;
      }
    },
  },
};
</script>

<style scoped>
.add-invitados-container {
  text-align: center;
  margin-top: 160px;
}
.contenedornodisp {
  position: relative;
  width: 100%;
  margin-top: 170px;
  padding: 0;
  box-sizing: border-box;
  overflow: auto;
}
.nodisponible2{

width: 100%; /* Asegura que el body ocupe todo el ancho */
  margin: 0 auto;
  text-align: center;
  margin-top:280px;
  padding: 0px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2 {
  color: #5f6770;
  font-family: 'Poppins', sans-serif; font-size: 28px;
  margin-bottom: 20px;
}

.video-container {
  width: 100%;
  max-width: 400px;
  margin: 20px auto;
  background: #eee;
  padding: 10px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
video {
  width: 100%;
  height: auto;
  border-radius: 8px;
}
.scanned-container {
  margin-top: 20px;
}
iframe {
  width: 100%;
  height: 400px;
  border: none;
  margin-top: 10px;
}
button {
  padding: 10px 20px;
  margin: 10px;
  cursor: pointer;
  background-color: #9a8f99; /* Un gris más oscuro */

}


button {
  background-color: transparent;
  border: 1px solid #5f6770;
  color: #5f6770;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 13px;
  font-family: 'Playfair Display', serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

button:hover {
  background-color: #5f6770;
  color: white;
}

</style>
